<template>
    <section
      class="relative gap-18 montserrat md:bottom-10 aboutHeder  md:h-[600px]   bg-center h-[700px] flex flex-col md:flex-row justify-between  transition-opacity duration-500 ease-out overflow-hidden"
      :style="{ backgroundImage: 'url(./assets/hero-background.jpg)', opacity: sectionOpacity }"
    >
      <!-- Left Section -->
      <div class="flex-1 montserrat relative left-4 md:left-20 animate__animated animate__bounceInLeft flex flex-col justify-center items-start    ">
        <h1 class="md:text-4xl text-xl font-bold text-white ">
            About Me
        </h1>
        <p class="text-xl md:text-xl text-white pt-2 md:pt-10">
            I am a  <span class="diffrent-color-just ">Engineer</span> turned <span class="diffrent-color-just">Product Designer</span> 
            currently<br> based in Chicago.
        </p>
        <p class="text-lg md:text-xl pt-2 md:pt-10 text-white">
          I recently completed my Masters in Human Computer<br> Interaction from DePaul University, Chicago Illinois.<br> 
        </p>
        <p class="text-lg md:text-xl pt-2 md:pt-10 text-white">
          Previously, earned my Bachelors in Engineering from Mumbai<br> University.
        </p>
      </div>
      <!-- Right Section -->
      <div v-if="isVisible" class="flex-1 relative mt-12 md:w-full flex flex-col items-center ">
        <!-- First Image (smaller and rotated) -->
        <img
          src="../assets/Subject.png"
          alt="Logo"
          class="w-8 absolute left-[55%] right-[50%] md:top-16 top-20 z-10 h-8 md:w-11 md:h-11 animate__animated animate__backInRight"
          :style="{ transform: 'rotate(15deg)' }"
        />
        <!-- Second Image (bigger and rotated) -->
        <div :style="{ transform: 'rotate(15deg)' }">
          <img
            class="animate__animated animate__slideInUp relative  w-80 h-96  md:w-[500px] md:h-auto mt-4"
            src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726624832/Group_1907_1_z9vjlm.png"
            alt="Animated Logo"
          />
        </div>
        <!-- Typing text at the end of the second image -->
        <div
          class=" relative right-6 garyaColor bottom-24 md:bottom-32 typewriter text-xs md:text-xl font-bold"
          :style="{ transform: 'rotate(15deg)' }"
        >
          {{ displayedText }}
        </div>
      </div>
    </section>
    <AboutSection/>
    <ButtonGroup/>
  </template>
  
  <script>

  export default {
    name: "AboutPageHeder",
    data() {
      return {
        isVisible: false,
        displayedText: "Parinistha Sharma",
        sectionOpacity: 1, // Default opacity
      };
    },
    mounted() {
      setTimeout(() => {
        this.isVisible = true;
      }, 1000); // Show after 1 second
      window.addEventListener("scroll", this.handleScroll);
    },
    beforeUnmount() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
      handleScroll() {
        const scrollPosition = window.scrollY;
        const fadeStart = 100; 
        const fadeEnd = 900; 
        if (scrollPosition >= fadeStart && scrollPosition <= fadeEnd) {
          this.sectionOpacity = 1 - (scrollPosition - fadeStart) / (fadeEnd - fadeStart);
        } else if (scrollPosition > fadeEnd) {
          this.sectionOpacity = 0;
        } else {
          this.sectionOpacity = 1;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Playwrite+CU:wght@100..400&display=swap');
  
  @keyframes typewriter {
    from {
      width: 0;
    }
    to {
      width: 34%;
    }
  }
  
  @keyframes blinkCursor {
    from {
      border-color: transparent;
    }
    to {
      border-color: black;
    }
  }
  @media (max-width:740px) {
  @keyframes typewriter {
    from {
      width: 0;
    }
    to {
      width: 55%;
    }
  }
  }
  .typewriter {
    overflow: hidden;
    white-space: nowrap;
    animation: typewriter 4s steps(40) 1s 1 normal both,
      blinkCursor 500ms steps(40) infinite normal;
  }
  
  .diffrent-color-just {
    color: #A0E9E5 !important;
  }
  .garyaColor{
    color: #1D2D31;
    font-family: "Playwrite CU", cursive;
    font-optical-sizing: auto;
  }
  @media (max-width:730px) {
    .aboutHeder{
      height: 900px;
    }
  }
  </style>
  